// Module
var code = "<div id=\"content\">\n    <p>지정한 키워드를 시열대별로 분석합니다.</p>\n</div>";
// Exports
module.exports = code;